'use strict';

import HtmlImage from './html-image';
import SvgIconImage from './svg-icon-image';

export { HtmlImage, SvgIconImage };
